import { Avatar } from "@mui/material";
import { useMemo } from "react";
import useUserContext from "../../../../../../context/useUserContext";

interface Props {
  clientCode: string;
}
const WorkbookFilterLabelLogo = ({ clientCode }: Props) => {
  const { clients } = useUserContext();
  const company = useMemo(() => {
    return clients.find((c) => c.clientCode === clientCode);
  }, [clients, clientCode]);

  return (
    <Avatar variant="rounded" sx={{ width: 24, height: 24 }} src={company?.branding.logoMarkUrl} alt={company?.title} />
  );
};

export default WorkbookFilterLabelLogo;
